import React, { useEffect, useState } from "react";
import logo from '../img/logo.png';
import '../css/Login.css';
import { IonIcon } from '@ionic/react';
import Swal from 'sweetalert';
import { wifiOutline, batteryFullOutline, cellularOutline, arrowBack, eye, eyeOff } from 'ionicons/icons';
import { Link, useNavigate } from 'react-router-dom';
import Carregamento from '../components/Carregamento';

// IMPORTAR FUNÇÕES
import { db, auth, ANO, entrarComServidor, logarResponsavel, logarServidor, cadastrar } from '../firebase/logar';


const reload = () => {
    window.location.reload();
}

const Login = () => {



    const navigate = useNavigate();

    // ITERAÇÃO COM O USUARIO
    const [horaAtual, setHoraAtual] = useState(new Date());
    const [mostrarMdCadastrar, setMdCadastrar] = useState(false);
    const [mostrarMdCadastrarTwo, setMdCadastrarTwo] = useState(false);
    const [mostrarMdLogarServidor, setMdLogarServidor] = useState(false);
    const [mostrarMdLogarResponsavel, setMdLogarResponsavel] = useState(false);
    const [mostrarMdRedefinirSenha, setMdRedefinirSenha] = useState(false);
    const [opcoesLogar, setOpcoesLogar] = useState(false);
    const [botoesLogar, setBotoesLogar] = useState(true);
    const [carregamento, setCarregamento] = useState(false);
    
    useEffect(() => {
        const intervalId = setInterval(() => {
            setHoraAtual(new Date());
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);
    const horas = formatDigit(horaAtual.getHours());
    const minutos = formatDigit(horaAtual.getMinutes());
    const segundos = formatDigit(horaAtual.getSeconds());

    const mdLogarServidor = () => {
        setMdLogarServidor(true);
        setOpcoesLogar(!opcoesLogar);
    };

    const mdLogarResponsavel = () => {
        setMdLogarResponsavel(true);
        setOpcoesLogar(!opcoesLogar);
    };

    const mdOpcoesLogar = () => {
        setOpcoesLogar(!opcoesLogar);
        setBotoesLogar(!botoesLogar);
    };

    const mdCadastrar = () => {
        setMdCadastrar(!mostrarMdCadastrar);
        setBotoesLogar(!botoesLogar);
    }

    const handleRedefinirSenha = () => {
        setMdLogarResponsavel(false);
        setMdRedefinirSenha(true);
    }

    const voltarOne = () => {
        setMdCadastrar(false);
        setOpcoesLogar(false);
        setMdRedefinirSenha(false);
        setBotoesLogar(true);
    };

    const voltarTwo = () => {
        setOpcoesLogar(true);
        setMdLogarResponsavel(false);
        setMdLogarServidor(false);
    };

    const voltarTree = () => {
        setMdRedefinirSenha(false);
        setMdLogarResponsavel(true);
    };

    // INPUT SERVIDOR
    const [logarNomeServidor, setInputLogarNomeServidor] = useState('');
    const [logarSenhaServidor, setInputLogarSenhaServidor] = useState('');

    // INPUT RESPONSAVEL
    const [logarNomeResponsavel, setInputLogarNomeResponsavel] = useState('');
    const [logarSenhaResponsavel, setInputLogarSenhaResponsavel] = useState('');

    // INPUT ALUNO
    const [logarNomeAluno, setInputLogarNomeAluno] = useState('');
    const [logarSenhaAluno, setInputLogarSenhaAluno] = useState('');
    
    // INPUT CADASTRAR
    const [cadastrarNomeResponsavel, setInputCadastrarNomeResponsavel] = useState('');
    const [cadastrarNomeAluno, setInputCadastrarNomeAluno] = useState('');
    const [cadastrarSerie, setInputCadastrarSerie] = useState('');
    const [cadastrarEmail, setInputCadastrarEmail] = useState('');
    const [cadastrarTelefoneResponsavel, setInputCadastrarTelefoneResponsavel] = useState('');
    const [cadastrarTelefoneAluno, setInputCadastrarTelefoneAluno] = useState('');
    const [cadastrarSenha, setInputCadastrarSenha] = useState('');
    const [redefinirSenhaEmail, setInputRedefinirSenhaEmail] = useState('');

    // ADICIONAR SERIES
    const listaSeries = localStorage.getItem('series');
    const series = listaSeries ? JSON.parse(listaSeries) : [];

    const handleLogarResponsavel = async () => {
        setCarregamento(true);
        const usuario = logarNomeResponsavel;
        const senha = logarSenhaResponsavel;
        try {
          const resposta = await logarResponsavel(usuario, senha, navigate);
          if (resposta) {
            setCarregamento(false);
          } else {
            setCarregamento(false);
          }
        } catch (error) {
          console.error('Erro ao autenticar responsável:', error.message);
        } finally {
          setCarregamento(false);
        }
    };

    const [acessos, setAcessos] = useState([]);
    const carregarAcessos = async (res) => {
      try {
        const snapshot = await db
          .collection(ANO)
          .doc('restrito')
          .collection(res)
          .doc('login')
          .collection('acessos')
          .get();
  
          const acessosData = snapshot.docs.map((doc) => ({
            nome: doc.id,
            servidor: res,
            // Adicione outras propriedades conforme necessário
          }));
          
          setAcessos(acessosData);
      } catch (error) {
        console.error('Erro ao obter acessos:', error.message);
      }
    };

    const handleLogarServidor = async () => {
        const usuario = logarNomeServidor;
        const senha = logarSenhaServidor;
        setCarregamento(true);
        try {
            const resposta = await logarServidor(usuario, senha, navigate);
            if (resposta) {
                setCarregamento(false);
            } else {
                setCarregamento(false);
            }
        } catch (error) {
            console.error('Erro ao autenticar responsável:', error.message);
        }
    };

    function capitalizar(val) {
        var texto = val;
        // Verifica se a entrada não está vazia
        if (texto.length === 0) {
          return texto;
        }
        // Divide a string em palavras
        var palavras = texto.split(' ');
        // Capitaliza a primeira letra de cada palavra
        for (var i = 0; i < palavras.length; i++) {
          palavras[i] = palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1).toLowerCase();
        }
        // Junta as palavras de volta em uma única string
        var resultado = palavras.join(' ');
        resultado = resultado.replace(/\s+/g, ' ');
        resultado = resultado.trim();
  
        return resultado;
    }

    const handleCadastrar = async () => {
        setCarregamento(true);
        try {
            const resultado = await cadastrar(
                cadastrarNomeResponsavel,
                cadastrarNomeAluno,
                cadastrarSerie,
                cadastrarEmail,
                cadastrarTelefoneResponsavel,
                cadastrarTelefoneAluno,
                cadastrarSenha,
                navigate,
            );
            if (resultado) {
                setCarregamento(false);
            } else {
                setCarregamento(false);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setCarregamento(false);
        }
    };

    async function mostrarSenha() {
        const inputs = document.querySelectorAll('.inputSenha');
        inputs.forEach((input) => {
            input.type = "text";
        });
        const iconsMostrar = document.querySelectorAll('.iconMostrar');
        const iconsEsconder = document.querySelectorAll('.iconEsconder');
        iconsMostrar.forEach(async (iconMostrar) => {
            await iconMostrar.classList.remove('none');
        });
        iconsEsconder.forEach(async (iconEsconder) => {
            await iconEsconder.classList.add('none');
        });
    }

    async function esconderSenha() {
        const inputs = document.querySelectorAll('.inputSenha');
        inputs.forEach(async (input) => {
            input.type = await "password";
        });
        const iconsMostrar = document.querySelectorAll('.iconMostrar');
        const iconsEsconder = document.querySelectorAll('.iconEsconder');
        iconsMostrar.forEach((iconMostrar) => {
            iconMostrar.classList.add('none');
        });
        iconsEsconder.forEach((iconEsconder) => {
            iconEsconder.classList.remove('none');
        });
    }


    function mudarTypeSenha() {
        const inputs = document.querySelectorAll('.inputSenha');
        const icones = document.querySelectorAll('.iconSenha');
        inputs.forEach(async (input, index) => {
            if (input.type === "text") {
                input.type = await "password";
                icones[index].src = eyeOff;
            } else {
                input.type = await "text";
                icones[index].src = eye;
            }
        });
    }

    // REDEFINIR SENHA
    const handleEnviarRedefinirSenha = async () => {
        
        setCarregamento(true);
        try {
            if (redefinirSenhaEmail) {
                await auth.sendPasswordResetEmail(redefinirSenhaEmail)
                .then(() => {
                    setCarregamento(false);
                    Swal({
                        title: `Link para redefinir sua senha enviado para o email ${redefinirSenhaEmail}.`,
                        icon: 'success',
                        buttons: {
                        confirm: 'Ok',
                        },
                    }).then((res) => {
                        voltarOne();
                    })
                    console.log('E-mail de redefinição de senha enviado para:', redefinirSenhaEmail);
                })
                .catch((error) => {
                    if (error.code === 'auth/invalid-email') {
                        Swal({
                          title: 'Email inválido!',
                          icon: 'error',
                          buttons: {
                            confirm: 'Ok',
                          },
                        });
                        setCarregamento(false);
                    } else if (error.code === 'auth/invalid-credential') {
                        Swal({
                          title: 'Email ou senha inválidos!',
                          icon: 'error',
                          buttons: {
                            confirm: 'Ok',
                          },
                        });
                        setCarregamento(false);
                    } else if (error.code === 'auth/user-disabled') {
                        Swal({
                          title: 'Sua conta foi desativada por um admin!',
                          icon: 'error',
                          buttons: {
                            confirm: 'Ok',
                          },
                        });
                        setCarregamento(false);
                    } else {
                        console.error('Erro ao enviar e-mail de redefinição de senha:', error.message);
                        setCarregamento(false);
                    }
                });
            } else {
                Swal({
                    title: `Digite um email válido!`,
                    icon: 'error',
                    buttons: {
                    confirm: 'Ok',
                    },
                });
                setCarregamento(false);
            }
            
        } catch (error) {
            console.log(error);
            setCarregamento(false);
        }
    };

    useEffect(() => {
        const logado = localStorage.getItem('logado');
        const usuario = localStorage.getItem('usuario');
        const login = localStorage.getItem('login');
        const email = localStorage.getItem('email');
        const senha = localStorage.getItem('senha');
        if (logado === 'off' && login === 'responsavel') {
            Swal({
                text: `Oops! Seu acesso expirou. Você deseja entrar novamente em sua conta!`,
                icon: 'warning',
                buttons: {
                    confirm: 'Sim',
                    cancel: 'Não',
                },
            }).then((res) => {
                if (res) {
                    setOpcoesLogar(false);
                    setBotoesLogar(false);
                    setMdLogarResponsavel(true);
                    setInputLogarNomeResponsavel(email);
                    setInputLogarSenhaResponsavel(senha);
                }    
            });
        } else if (logado === 'off' && login !== 'responsavel') {
            Swal({
                text: `Oops! Seu acesso expirou. Você deseja entrar novamente em sua conta!`,
                icon: 'warning',
                buttons: {
                    confirm: 'Sim',
                    cancel: 'Não',
                },
            }).then((res) => {
                if (res) {
                    setOpcoesLogar(false);
                    setBotoesLogar(false);
                    setMdLogarServidor(true);
                    setInputLogarNomeServidor(email);
                    setInputLogarSenhaServidor(senha);
                }    
            });
        }
    }, []);


    const formatarCadastrarTelefoneResponsavel = (telefone) => {

        const formattedTelefone = telefone.replace(/\D/g, '');
        
        let formattedString = '';

        // EX: (16) 99962-1296
        if (formattedTelefone.length >= 12) {
            formattedString = `(${formattedTelefone.substring(0,2)}) ${formattedTelefone.substring(2, 7)}-${formattedTelefone.substring(7, 11)}`;
        } else if (formattedTelefone.length <= 2) {
            // Digitar o 2º numero adicione '(' no ndex 0 e ')' no index 2
            formattedString = `(${formattedTelefone})`;
        } else if (formattedTelefone.length <= 7) {
            // Digitar o 2º numero adicione '(' no ndex 0 e ')' no index 2
            formattedString = `(${formattedTelefone.substring(0,2)}) ${formattedTelefone.substring(2)}`;
        } else if (formattedTelefone.length >= 7) {
            // Digitar o 2º numero adicione '(' no ndex 0 e ')' no index 2
            formattedString = `(${formattedTelefone.substring(0,2)}) ${formattedTelefone.substring(2, 7)}-${formattedTelefone.substring(7)}`;
        }

        setInputCadastrarTelefoneResponsavel(formattedString);
    };


    const formatarCadastrarTelefoneAluno = (telefone) => {

        const formattedTelefone = telefone.replace(/\D/g, '');
        
        let formattedString = '';

        // EX: (16) 99962-1296
        if (formattedTelefone.length >= 12) {
            formattedString = `(${formattedTelefone.substring(0,2)}) ${formattedTelefone.substring(2, 7)}-${formattedTelefone.substring(7, 11)}`;
        } else if (formattedTelefone.length <= 2) {
            // Digitar o 2º numero adicione '(' no ndex 0 e ')' no index 2
            formattedString = `(${formattedTelefone})`;
        } else if (formattedTelefone.length <= 7) {
            // Digitar o 2º numero adicione '(' no ndex 0 e ')' no index 2
            formattedString = `(${formattedTelefone.substring(0,2)}) ${formattedTelefone.substring(2)}`;
        } else if (formattedTelefone.length >= 7) {
            // Digitar o 2º numero adicione '(' no ndex 0 e ')' no index 2
            formattedString = `(${formattedTelefone.substring(0,2)}) ${formattedTelefone.substring(2, 7)}-${formattedTelefone.substring(7)}`;
        }

        setInputCadastrarTelefoneAluno(formattedString);
    };

    return (
        <main className="container-login">
            
            <div className="before">
                <p id="hora">
                    {horas}:{minutos}:{segundos}
                </p>
                <div className="flex">
                    <IonIcon icon={wifiOutline} />
                    <IonIcon icon={cellularOutline} />
                    <IonIcon icon={batteryFullOutline} />
                </div>
            </div>

            {carregamento && (
                <div className="carregando">
                    <span></span>
                    <h1>Carregando..</h1>
                </div>
            )}
            
            {botoesLogar && (
                <div className="width">
                <section className="container-logo-login">
                    <div className="content-logo-login">
                            <img src={require('../img/logo.png')} alt="Logo da escola" />
                        </div>
                    </section>
                    <section className="content-botoes-login">
                        <button onClick={mdOpcoesLogar}>Logar</button>
                        <p>Sem cadastro? <a onClick={mdCadastrar}>Cadastrar</a></p>
                    </section>
                </div>
            )}

            {opcoesLogar && (
                <div className="width">
                    <section className="container-logo-login logando">
                        <div className="content-logo-login logando">
                            <h1>Logar</h1>
                            <IonIcon onClick={voltarOne} icon={arrowBack} />
                        </div>
                    </section>
                    <section className="content-login">
                        <h1>Selecione o ambiente em que deseja fazer o login</h1>
                        <button onClick={() => mdLogarServidor()}>Servidor</button>
                        <button onClick={() => mdLogarResponsavel()}>Responsável</button>
                        {/*<button onClick={() => mdLogarAluno()}>Aluno</button>*/}
                    </section>
                </div>
            )}

            {mostrarMdLogarServidor && (
                <div className="width">
                    <section className="container-logo-login logando">
                        <div className="content-logo-login logando">
                            <h1>Logar como Servidor</h1>
                            <IonIcon onClick={voltarTwo} icon={arrowBack} />
                        </div>
                    </section>
                    <section className="content-login">
                        <div className="form-tecvit form-login">
                            
                            <div className="flex">
                                <input onChange={(e) => setInputLogarNomeServidor(e.target.value)} value={logarNomeServidor} placeholder=" " type="text" />    
                                <label>Email</label>
                            </div>

                            <div className="flex">
                                <input className="inputSenha" onChange={(e) => setInputLogarSenhaServidor(e.target.value)} value={logarSenhaServidor} placeholder=" " type="password" />
                                <label>Senha</label>
                                <IonIcon className="iconSenha" onClick={() => mudarTypeSenha()} icon={eyeOff} />
                            </div>
                            
                            <div className="flex">
                                <button onClick={handleLogarServidor}>
                                    {carregamento ? (
                                        <Carregamento />
                                    ) : (
                                        <>Logar</>
                                    )}
                                </button>
                            </div>

                            <div className="termosGerais">
                                <p>
                                    Ao usar o Aplicativo você concorda com os
                                    <br />
                                    <Link to="/security/termos">
                                        <a> Termos de Uso </a>
                                    </Link>
                                    e
                                    <Link to="/security/privacidade">
                                      <a> Política de Privacidade </a>
                                    </Link>
                                </p>
                            </div>

                        </div>
                    </section>
                </div>
            )}

            {mostrarMdLogarResponsavel && (
                <div className="width">
                    <section className="container-logo-login logando">
                        <div className="content-logo-login logando">
                            <h1>Logar como Responsável</h1>
                            <IonIcon onClick={voltarTwo} icon={arrowBack} />
                        </div>
                    </section>
                    <section className="content-login">
                        <div className="form-tecvit form-login">
                            
                            <div className="flex">
                                <input onChange={(e) => setInputLogarNomeResponsavel(e.target.value)} value={logarNomeResponsavel} placeholder=" " type="text" />    
                                <label>Email</label>
                            </div>

                            <div className="flex">
                                <input className="inputSenha" onChange={(e) => setInputLogarSenhaResponsavel(e.target.value)} value={logarSenhaResponsavel} placeholder=" " type="password" />
                                <label>Senha</label>
                                <IonIcon className="iconSenha" onClick={() => mudarTypeSenha()} icon={eyeOff} />
                            </div>
                            
                            <div className="flex">
                                <button onClick={handleLogarResponsavel}>
                                    {carregamento ? (
                                        <Carregamento />
                                    ) : (
                                        <>Logar</>
                                    )}
                                </button>
                            </div>

                            <p>Esqueceu sua senha? <a onClick={handleRedefinirSenha}>Redefinir Senha</a></p>

                            <div className="termosGerais">
                                <p>
                                    Ao usar o aplicativo você concorda com os
                                    <br />
                                    <Link to="/security/termos">
                                        <a> Termos de Uso </a>
                                    </Link>
                                    e
                                    <Link to="/security/privacidade">
                                      <a> Política de Privacidade </a>
                                    </Link>
                                </p>
                            </div>
                            
                        </div>
                    </section>
                </div>
            )}

            {mostrarMdRedefinirSenha && (
                <div className="width">
                    <section className="container-logo-login logando">
                        <div className="content-logo-login logando">
                            <h1>Redefinir Senha</h1>
                            <IonIcon onClick={voltarTree} icon={arrowBack} />
                        </div>
                    </section>
                    <section className="content-login">
                        <div className="form-tecvit form-login">
                            
                            <div className="flex">
                                <input onChange={(e) => setInputRedefinirSenhaEmail(capitalizar(e.target.value))} placeholder=" " type="text" />    
                                <label>Digite seu Email</label>
                            </div>

                            <div className="flex">
                                <button onClick={handleEnviarRedefinirSenha}>
                                    {carregamento ? (
                                        <div className="icon-carregamento"></div>
                                    ) : (
                                        <>Redefinir Senha</>
                                    )}
                                </button>
                            </div>

                            <div className="termosGerais">
                                <p>
                                    Ao usar o aplicativo você concorda com os
                                    <br />
                                    <Link to="/security/termos">
                                        <a> Termos de Uso </a>
                                    </Link>
                                    e
                                    <Link to="/security/privacidade">
                                      <a> Política de Privacidade </a>
                                    </Link>
                                </p>
                            </div>

                        </div>
                    </section>
                </div>
            )}

            {/*mostrarMdLogarAluno && (
                <div className="width">
                    <section className="container-logo-login logando">
                        <div className="content-logo-login logando">
                            <h1>Logar como Aluno</h1>
                            <IonIcon onClick={() => reload()} icon={arrowBack} />
                        </div>
                    </section>
                    <section className="content-login">
                        <div className="form-login">
                            
                            <div className="column">
                                <label>Nome do Aluno</label>
                                <input onChange={(e) => setInputLogarNomeAluno(e.target.value)} type="text" />    
                            </div>

                            <div className="column">
                                <label>Senha</label>
                                <div className="flex">
                                    <input className="inputSenha" onChange={(e) => setInputLogarSenhaAluno(e.target.value)} id="senha" type="password" />
                                    <IonIcon onClick={() => mudarTypeSenha()} className="iconSenha" icon={eyeOff} />
                                </div>
                            </div>
                            
                            <div className="column">
                                <button onClick={handleLogarAluno}>Logar</button>
                            </div>

                            <div className="termosGerais">
                                <p>
                                    Ao usar o Aplicativo você concorda com os
                                    <br />
                                    <Link to="/security/termos">
                                        <a> Termos de Uso </a>
                                    </Link>
                                    e
                                    <Link to="/security/privacidade">
                                      <a> Política de Privacidade </a>
                                    </Link>
                                </p>
                            </div>
                            
                        </div>
                    </section>
                </div>
            )*/}

            {mostrarMdCadastrar && (
                <div className="width">
                    <section className="container-logo-login logando">
                        <div className="content-logo-login logando">
                            <h1> Fazer Cadastro </h1>
                            <IonIcon onClick={voltarOne} icon={arrowBack} />
                        </div>
                    </section>
                    <section className="content-login">
                        <div className="form-tecvit form-login">
                            
                            <div className="progresso total50">
                                <div className="flex">
                                    <strong>1</strong>
                                    <p>Cadastrar Dados</p>
                                </div>
                                <span>50%</span>
                            </div>

                            <div className="flex">
                                <input onChange={(e) => setInputCadastrarNomeResponsavel(e.target.value)} value={cadastrarNomeResponsavel} placeholder=" " type="text" />    
                                <label>Nome do Responsável</label>
                            </div>

                            <div className="flex">
                                <input onChange={(e) => setInputCadastrarNomeAluno(e.target.value)} value={cadastrarNomeAluno} placeholder=" " type="text" />    
                                <label>Nome do Aluno</label>
                            </div>

                            <div className="flex">
                                <select id="series" onChange={(e) => setInputCadastrarSerie(e.target.value)} value={cadastrarSerie}>            
                                    <option value="">Escolha uma série</option>
                                    {series.length > 0 ? (
                                        series.map((serie, index) => (
                                            <option key={index} value={serie}>
                                                {serie}
                                            </option>
                                        ))
                                        ) : (
                                        <option value="">Nenhuma série disponível</option>
                                    )}
                                </select>    
                                <label>Série</label>
                            </div>

                            <div className="flex">
                                <input value={cadastrarTelefoneResponsavel} onChange={(e) => formatarCadastrarTelefoneResponsavel(e.target.value)} type="text" placeholder="Opcional" />    
                                <label>Telefone do Responsável</label>
                            </div>

                            <div className="flex">
                                <input onChange={(e) => formatarCadastrarTelefoneAluno(e.target.value)} value={cadastrarTelefoneAluno} type="text" placeholder="Opcional" />    
                                <label>Telefone do Aluno</label>
                            </div>
 
                            <div className="flex">
                                <button onClick={() => {
                                    setMdCadastrar(false);
                                    setMdCadastrarTwo(true)
                                }}>Próximo</button>
                            </div>

                        </div>
                    </section>
                </div>
            )}

            {mostrarMdCadastrarTwo && (
                <div className="width">
                    <section className="container-logo-login logando">
                        <div className="content-logo-login logando">
                            <h1> Fazer Cadastro </h1>
                            <IonIcon onClick={() => {
                                setMdCadastrar(true);
                                setMdCadastrarTwo(false)
                            }} icon={arrowBack} />
                        </div>
                    </section>
                    <section className="content-login">
                        <div className="form-tecvit form-login">
                            
                            <div className="progresso total100">
                                <div className="flex">
                                    <strong>2</strong>
                                    <p>Cadastrar Email e Senha</p>
                                </div>
                                <span>100%</span>
                            </div>

                            <div className="flex">
                                <input onChange={(e) => setInputCadastrarEmail(e.target.value)} value={cadastrarEmail} type="text" placeholder=" " />    
                                <label>Email</label>
                            </div>

                            
                            <div className="flex">
                                <input className="inputSenha" onChange={(e) => setInputCadastrarSenha(e.target.value)} value={cadastrarSenha} placeholder=" " type="password" />
                                <label>Senha</label>
                                <IonIcon className="iconSenha" onClick={() => mudarTypeSenha()} icon={eyeOff} />
                            </div>
                            
                            <div className="flex">
                                <button onClick={handleCadastrar}>
                                    {carregamento ? (
                                        <div className="icon-carregamento"></div>
                                    ) : (
                                        <>Cadastrar</>
                                    )}
                                </button>
                                
                                <button className="fechar" onClick={() => {
                                    setMdCadastrar(true);
                                    setMdCadastrarTwo(false)
                                }}>Voltar</button>
                            </div>


                            

                        </div>
                    </section>
                </div>
            )}


            <div className="carregando">
                <div className="popup-logar">
                    <ul>
                        <h1>Selecione qual conta logar</h1>
                        {acessos.map((acesso) => (
                            <li onClick={() => entrarComServidor(acesso.servidor, acesso.nome, logarSenhaServidor)}>
                                <h2>{acesso.nome}</h2>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>       

        </main>
    );
}

export default Login;